export default class ToolsHelper {
  public static formatPrice(value) {
    if (!value) {
      value = '0';
    }
    if (typeof value === 'string') {
      value = value.replace(',', '');
    }
    return (
      parseFloat(value)
        .toFixed(2)
        .replace('.', ',') + ' €'
    );
  }
}
